import omit from 'lodash/omit'

// 从树中查找目标，结果为对象
export const findFromTree = (key, tree, config = { keyPropName: 'id', childrenPropName: 'children', leaf: false }) => {
    const { keyPropName, childrenPropName, leaf } = config

    for (let v of tree) {
        if (!leaf || !Array.isArray(v[childrenPropName])) {
            if (key === v[keyPropName]) {
                return v
            }
        }

        if (Array.isArray(v[childrenPropName]) && v[childrenPropName].length) {
            const res = findFromTree(key, v[childrenPropName], config)

            if (res) {
                return res
            }
        }
    }
}

// 打平树
export const flatTree = (tree, config = { keyPropName: 'id', childrenPropName: 'children' }, parent = []) => {
    const { childrenPropName } = config

    if (!Array.isArray(tree)) {
        return []
    }

    return tree.reduce((t, c) => {
        const children = c[childrenPropName]

        if (Array.isArray(children) && children.length) {
            const p = parent.concat(omit(c, [childrenPropName]))

            return t.concat(flatTree(children, config, p))
        }

        t.push([...parent, c])

        return t
    }, [])
}

// 从树中查找完整节点列表
export const findFullNodeFromTree = (
    key,
    tree,
    config = { keyPropName: 'id', childrenPropName: 'children', leaf: true }
) => {
    const { keyPropName, leaf } = config

    if (typeof key === 'undefined' || key === null || !Array.isArray(tree)) {
        return []
    }

    const fTree = flatTree(tree, config)

    return (
        fTree.find(v => {
            if (leaf) {
                const leafNode = v[v.length - 1]

                return key === leafNode[keyPropName]
            }

            return v.some(c => c[keyPropName] === key)
        }) || []
    )
}

// 转化树   type = 'string' 的时候 值转化为 string 列下
export const transTreeKeys = (tree, config = { keyMap: { id: 'value' }, childrenPropName: 'children', type: null }) => {
    const { keyMap, childrenPropName, type } = config

    if (!Array.isArray(tree)) {
        return []
    }

    const oldKeys = Object.keys(keyMap)

    return tree.map(v => {
        const obj = {
            ...omit(v, oldKeys),
            ...oldKeys.reduce((t, oldKey) => {
                const newKey = keyMap[oldKey]

                if (type === 'string') {
                    t[newKey] = String(v[oldKey])
                } else {
                    t[newKey] = v[oldKey]
                }

                return t
            }, {})
        }

        const children = v[childrenPropName]

        if (Array.isArray(children)) {
            obj[childrenPropName] = transTreeKeys(children, config)
        }

        return obj
    })
}

export const visitTree = (tree, callback) => {
    if (Array.isArray(tree)) {
        tree.forEach((v, k) => {
            callback(v, k)

            if (Array.isArray(v.children)) {
                visitTree(v.children, callback)
            }
        })
    }
}

export const flatTreeToOneLevel = (tree, config = { childrenPropName: 'children', skipHasChidlrenNode: false }) => {
    const { childrenPropName, skipHasChidlrenNode } = config

    if (!Array.isArray(tree)) {
        return []
    }

    return tree.reduce((t, c) => {
        const children = c[childrenPropName]

        const hasChildren = Array.isArray(children) && children.length

        if (!hasChildren || !skipHasChidlrenNode) {
            t.push(c)
        }

        if (hasChildren) {
            return t.concat(flatTreeToOneLevel(children, config))
        }

        return t
    }, [])
}
